<template>
  <div class="app-container editSportManage">
    <el-card>
      <div slot="header" class="clearfix">
        <h3 class="pageName">{{ pageName }}</h3>
      </div>
      <el-form
        ref="setform"
        :model="gameInfo"
        size="mini"
        :rules="rules"
        label-width="120px"
        v-loading="loading"
        class="setform"
      >
        <el-form-item label="赛事标题" prop="gameName">
          <el-input
            v-model="gameInfo.gameName"
            placeholder="输入赛事标题"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="赛事封面图" prop="gameImg">
          <div :class="{ got: !!gameInfo.gameImg }">
            <el-upload
              :limit="1"
              :action="action"
              :file-list="fileList1"
              list-type="picture-card"
              accept=".jpg, .png, .jpeg"
              :on-success="changeCover1"
              :headers="headers"
              :on-remove="removeCover1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <!-- <el-form-item label="赛事项目" prop="itemName">
          <el-input
            v-model="gameInfo.itemName"
            placeholder="输入赛事项目"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item label="举办方" prop="conductHost">
          <el-input
            v-model="gameInfo.conductHost"
            placeholder="输入举办方"
            clearable
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <el-form-item label="承办方" prop="contractor">
          <el-input
            v-model="gameInfo.contractor"
            placeholder="输入承办方"
            clearable
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <el-form-item label="举办点" prop="detailedAddress">
          <el-input
            v-model="gameInfo.detailedAddress"
            placeholder="输入举办点"
            clearable
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <el-form-item label="报名时间" prop="bmTime">
          <el-date-picker
            v-model="gameInfo.bmTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="报名时间"
            end-placeholder="报名时间"
            @change="changeBmTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="举办时间" prop="jbTime">
          <el-date-picker
            v-model="gameInfo.jbTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="举办时间"
            end-placeholder="举办时间"
            @change="changeJbTime"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="赛事形式" prop="gameGenre">
          <el-input
            v-model="gameInfo.gameGenre"
            placeholder="输入赛事形式"
            clearable
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="参与人数" prop="limitQuantity">
          <el-input
            v-model="gameInfo.limitQuantity"
            placeholder="输入参与人数"
            clearable
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="赛事赛制" prop="gameCompetitionSystem">
          <el-input
            v-model="gameInfo.gameCompetitionSystem"
            placeholder="输入赛事赛制"
            clearable
            @change="$forceUpdate()"
          ></el-input>
        </el-form-item> -->

        <!-- 文件上传-start -->
        <el-form-item label="赛事秩序册" prop="orderFile" class="formItemLine">
          <el-upload
            :limit="1"
            class="upload-demo"
            :action="action"
            :file-list="fileList2"
            accept=".xls, .xlsx, .doc, .docx"
            :on-success="changeCover2"
            :headers="headers"
            :on-remove="removeCover2"
          >
            <el-button size="small" type="primary">上传赛事秩序册</el-button>
            <span slot="tip" class="el-upload__tip tipTxt"
              >可上传xls/xlsx/doc/docx文件</span
            >
          </el-upload>
        </el-form-item>

        <el-form-item
          label="成绩册"
          prop="gameRegulationFile"
          class="formItemLine"
        >
          <el-upload
            :limit="1"
            class="upload-demo"
            :action="action"
            :file-list="fileList3"
            accept=".xls, .xlsx"
            :on-success="changeCover3"
            :headers="headers"
            :on-remove="removeCover3"
          >
            <el-button size="small" type="primary">上传成绩册</el-button>
            <span slot="tip" class="el-upload__tip tipTxt"
              >可上传xls/xlsx文件</span
            >
          </el-upload>
        </el-form-item>
        <!-- 文件上传-end -->
      </el-form>
      <div class="footerBtn">
        <el-button type="primary" @click="submitForm">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as API_Game from "@/api/sportManage/game";
import store from "@/store/index";
export default {
  name: "addGame",
  data() {
    return {
      action: process.env.VUE_APP_BASE_API + "/api/file/uploadOss",
      headers: {
        system: 0,
        token: store.state.token,
      },
      loading: false,
      fileList1: [],
      fileList2: [],
      fileList3: [],
      gameInfo: {
        applyEndTime: "0",
        applyStartTime: "",
        cityNo: "",
        conductHost: "",
        contractor: "",
        detailedAddress: "",
        gameCompetitionSystem: "",
        gameEndTime: "",
        gameGenre: "",
        gameImg: "",
        gameName: "",
        gameStartTime: "",
        isApply: "2",
        isDrafts: 2,
        limitQuantity: "",
        isLimit: "2",
        provinceNo: "",
        townNo: "",
        typeItemList: [{ typeId: 3, itemId: 35 }],
        state: 3,
        gameRegulationFile: "",
      },
      pageName: "添加赛事",
      rules: {
        gameName: [
          {
            required: true,
            message: "请输入赛事标题",
            trigger: "blur",
          },
        ],
        itemName: [
          {
            required: true,
            message: "请输入赛事项目",
            trigger: "blur",
          },
        ],
        conductHost: [
          {
            required: true,
            message: "请输入举办方",
            trigger: "blur",
          },
        ],
        contractor: [
          {
            required: true,
            message: "请输入承办方",
            trigger: "blur",
          },
        ],
        detailedAddress: [
          {
            required: true,
            message: "请输入举办地点",
            trigger: "blur",
          },
        ],
        gameGenre: [
          {
            required: true,
            message: "请输入赛事形式",
            trigger: "blur",
          },
        ],
        limitQuantity: [
          {
            required: true,
            message: "请输入赛事报名人数",
            trigger: "blur",
          },
        ],
        gameCompetitionSystem: [
          {
            required: true,
            message: "请输入赛事赛制",
            trigger: "blur",
          },
        ],
        gameImg: [
          {
            required: true,
            message: "请上传封面图",
            trigger: "change",
          },
        ],
        bmTime: [
          {
            required: true,
            message: "请输入报名时间",
            trigger: "change",
          },
        ],
        jbTime: [
          {
            required: true,
            message: "请输入举办时间",
            trigger: "change",
          },
        ],
        orderFile: [
          {
            required: true,
            message: "请上传赛事秩序册",
            trigger: "change",
          },
        ],
        gameRegulationFile: [
          {
            required: true,
            message: "请上传成绩册",
            trigger: "change",
          },
        ],
        // itemImg: [
        //   {
        //     required: true,
        //     message: "请上传赛事项目图标",
        //     trigger: "change",
        //   },
        // ],
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.gameInfo.id = this.$route.query.id;
      this.pageName = "编辑赛事";
      this._getDetail();
    } else {
      this.pageName = "添加赛事";
    }
  },
  methods: {
    // 接口-赛事详情
    _getDetail() {
      API_Game.gameInfo({
        id: this.gameInfo.id,
      }).then((res) => {
        this.gameInfo = res.data;
        this.fileList1.push({ url: res.data.gameImg, name: res.data.gameImg });
        this.fileList2.push({
          url: res.data.orderFile,
          name: res.data.orderFile,
        });
        this.fileList3.push({
          url: res.data.gameRegulationFile,
          name: res.data.gameRegulationFile,
        });
        this.gameInfo.bmTime = [res.data.applyStartTime, res.data.applyEndTime];
        this.gameInfo.jbTime = [res.data.gameStartTime, res.data.gameEndTime];
        console.log(this.gameInfo);
      });
    },

    // 取消
    cancel() {
      this.$router.go(-1);
    },

    // 保存
    submitForm() {
      this.$refs["setform"].validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            // this.gameInfo
            applyStartTime: this.gameInfo.bmTime[0],
            applyEndTime: this.gameInfo.bmTime[1],
            cityNo: "",
            conductHost: this.gameInfo.conductHost,
            contractor: this.gameInfo.contractor,
            detailedAddress: this.gameInfo.detailedAddress,
            gameCompetitionSystem: this.gameInfo.gameCompetitionSystem,
            gameGenre: this.gameInfo.gameGenre,
            gameImg: this.gameInfo.gameImg,
            gameName: this.gameInfo.gameName,
            gameStartTime: this.gameInfo.jbTime[0],
            gameEndTime: this.gameInfo.jbTime[1],
            isApply: "2",
            isDrafts: 2,
            limitQuantity: this.gameInfo.limitQuantity,
            isLimit: "2",
            provinceNo: "",
            townNo: "",
            orderFile: this.gameInfo.orderFile,
            typeItemList: [{ typeId: 3, itemId: 35 }],
            state: 3,
            gameRegulationFile: this.gameInfo.gameRegulationFile,
          };
          if (this.gameInfo.id) {
            data.id = this.gameInfo.id;
          }
          API_Game.holdMatch(data).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.loading = false;
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeBmTime(e) {
      this.gameInfo.applyStartTime = e[0];
      this.gameInfo.applyEndTime = e[1];
    },

    changeJbTime(e) {
      this.gameInfo.gameStartTime = e[0];
      this.gameInfo.gameEndTime = e[1];
    },

    changeCover1(e) {
      this.gameInfo.gameImg = e.data.url;
      this.$forceUpdate();
    },
    changeCover2(e) {
      this.gameInfo.orderFile = e.data.url;
      this.$forceUpdate();
    },
    changeCover3(e) {
      this.gameInfo.gameRegulationFile = e.data.url;
      this.$forceUpdate();
    },
    removeCover1() {
      this.gameInfo.gameImg = "";
      this.$forceUpdate();
    },
    removeCover2() {
      this.gameInfo.orderFile = "";
      this.$forceUpdate();
    },
    removeCover3() {
      this.gameInfo.gameRegulationFile = "";
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss" scoped>
.setform {
  max-width: 800px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 30px;
  line-height: 30px;
}
::v-deep .el-form-item--mini .el-form-item__label {
  height: 30px;
  line-height: 30px;
}
::v-deep .upload-demo .el-upload .el-button {
  background-color: inherit;
  color: #1890ff;
  border-color: #1890ff;
  &:hover {
    background-color: #1890ff;
    color: #fff;
  }
}
::v-deep .formItemLine {
  margin-top: 20px;
  margin-bottom: 0px !important;
}
::v-deep .el-form-item--mini.el-form-item {
  margin-bottom: 25px;
}
::v-deep .formItemLine .upload-demo {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding-bottom: 18px;
  margin-bottom: 5px;
}
.tipTxt {
  margin-left: 10px;
  // margin-top: 5px;
  color: rgba(255, 255, 255, 0.5);
}
.footerBtn {
  margin-left: 120px;
  margin-top: 20px;
}
</style>
